import React, { Children } from 'react';
interface ContentSectionProps {
  id: string;
  title: string;
  text: React.ReactNode;
  imageSrc?: string;
  imageAlt?: string;
  reversed?: boolean;
  bgColor?: string;
}
export function ContentSection({
  id,
  title,
  text,
  imageSrc,
  imageAlt,
  reversed = false,
  bgColor = 'bg-white'
}: ContentSectionProps) {
  return <section id={id} className={`py-24 ${bgColor}`} data-id="element-9" data-mp="lr8ypgsjwwkx">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-10" data-mp="gsz3x7aqnxzu">
        <div className={`flex flex-col md:flex-row items-center gap-12 lg:gap-20 ${reversed ? 'md:flex-row-reverse' : ''}`} data-id="element-11" data-mp="gua652ojcxou">
          {/* Text Content */}
          <div className="flex-1 text-center md:text-left" data-id="element-12" data-mp="735ti9mc1ox6">
            <h2 className="text-3xl md:text-4xl font-bold text-[#3b2316] mb-6" data-id="element-13" data-mp="31tx9l8ye5g0">
              {title}
            </h2>
            <div className="text-xl text-[#5a3a28]/80 leading-relaxed" data-id="element-14" data-mp="3u60qwpguvp2b">
              {text}
            </div>
          </div>

          {/* Circular Image Content */}
          <div className="flex-1 w-full flex justify-center" data-id="element-15" data-mp="3hk2df47tnw70">
            {imageSrc ? <div className="relative" data-id="element-16" data-mp="3mb2ac9gxye9i">
                {/* Shadow/glow effect */}
                <div className="absolute inset-0 rounded-full bg-[#d4956a]/20 blur-2xl scale-110" data-id="element-17" data-mp="3md56lb8ot3mo"></div>
                {/* Image container */}
                <div className="relative w-64 h-64 md:w-80 md:h-80 rounded-full overflow-hidden shadow-2xl ring-4 ring-white" data-id="element-18" data-mp="3dk20jo0dft22">
                  <img src={imageSrc} alt={imageAlt || title} className="w-full h-full object-cover" data-id="element-19" data-mp="53yqxcpp7ub3" />
                </div>
              </div> : <div className="relative" data-id="element-20" data-mp="3u8hh58cpi8">
                <div className="absolute inset-0 rounded-full bg-[#ecdfd2] blur-2xl scale-110" data-id="element-21" data-mp="2sw99ch9wyx"></div>
                <div className="relative w-64 h-64 md:w-80 md:h-80 rounded-full bg-[#ecdfd2]/30 flex items-center justify-center shadow-xl ring-4 ring-white" data-id="element-22" data-mp="2fugur9753xju">
                  <span className="text-[#d4956a] font-medium" data-id="element-23" data-mp="20ryspm0xu10c">Image</span>
                </div>
              </div>}
          </div>
        </div>
      </div>
    </section>;
}